

export  const validatePostalCodeAgainstProvince = function(postalcode, province ){
    let provincePostalCode = {
        R:"MB",
        S:"SK",
        T:"AB",
        E:"NB",
        V:"BC",
        M:"ON",
        P:"ON",
        K:"ON",
        N:"ON",
        X:"NT",
        L:"ON",
        C:"PE",
        B:"NS",
        Y:"YT",
        A:"NL",
        G:"QC",
        H:"QC",
        J:"QC"
    };

    if (postalcode === null || province === null)
        return false;
    let firstLetter = postalcode.substring(0,1);
    
    if (provincePostalCode[firstLetter] === province)
        return true;
    return false;


}